import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { WorkspaceProvider } from '../context/WorkspaceContext';
import { TemplateCacheProvider } from '../hooks/useTemplateCache';
import SideMenu from '../components/navigation/SideMenu';
import * as Sentry from '@sentry/react';

const PageErrorFallback: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="flex items-center justify-center h-full">
      <div className="text-center max-w-md">
        <h2 className="text-lg font-semibold text-cm-text-primary mb-2">This page crashed</h2>
        <p className="text-sm text-cm-text-muted mb-4">
          The error has been reported. You can try going back or navigating to another page.
        </p>
        <button
          onClick={() => navigate(-1)}
          className="px-4 py-2 bg-cm-accent-orange text-white rounded-lg text-sm hover:opacity-90 transition-opacity"
        >
          Go back
        </button>
      </div>
    </div>
  );
};

const WorkspaceLayout: React.FC = () => {
  return (
    <WorkspaceProvider>
      <TemplateCacheProvider>
        <div className="flex h-screen bg-cm-bg-deep text-cm-text-primary">
          {/* Side Navigation */}
          <SideMenu className="flex-shrink-0" />

          {/* Main Content Area */}
          <div className="flex-1 flex flex-col overflow-hidden">
            {/* Page Content */}
            <main className="flex-1 overflow-auto p-4">
              <Sentry.ErrorBoundary fallback={<PageErrorFallback />}>
                <Outlet />
              </Sentry.ErrorBoundary>
            </main>
          </div>
        </div>
      </TemplateCacheProvider>
    </WorkspaceProvider>
  );
};

export default WorkspaceLayout;
